import { z } from "zod";

import { TimeReportProjectPayCode } from "./TimeReportProjectPayCode";

export const TimeReportProjectSummaryItem = TimeReportProjectPayCode.merge(
  z.object({
    effectiveClientRate: z.number(),
  }),
);

export type TimeReportProjectSummaryItem = z.infer<typeof TimeReportProjectSummaryItem>;
